import React, { useState } from "react";
import { Container, Grid, TextField, Button, Typography } from "@mui/material";
import LanguageCheckboxGroup from "../../reuseAbleComponent/LanguageCheckboxGroup";
import { submitLanguageSurveyForm } from "../api"; 
import {  useLocation , useNavigate} from 'react-router-dom';
import { notifySuccess, notifyError } from '../Notification';
import ThankYouModal from '../layout/ThankyouModal';
const LanguageSurveyForm = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const closeModal = () => {
      setModalVisible(false);  
    };
  const location = useLocation();
    const navigate = useNavigate();
  const child = location.state?.child;
  const initialFormData = {
    languages: {
      Urdu: false,
      English: false,
      Punjabi: false,
      Sindhi: false,
      Balochi: false,
      Pashto: false,
      Gujarati: false,
      Seraiki: false,
      Balti: false,
      Memoni: false,
      Kashmiri: false,
      Brahui: false,
      Hindko: false,
      Shina: false,
      other: false,
      otherLanguage: '',
    },
    schoolLanguages: {
      Urdu: false,
      English: false,
      French: false,
      Spanish: false,
    },
    motherLanguages: {
      Urdu: false,
      English: false,
      Punjabi: false,
      Sindhi: false,
      Balochi: false,
      Pashto: false,
      Gujarati: false,
      Seraiki: false,
      Balti: false,
      Memoni: false,
      Kashmiri: false,
      Brahui: false,
      Hindko: false,
      Shina: false,
      other: false,
      otherLanguage: '',
    },
    fatherLanguages: {
      Urdu: false,
      English: false,
      Punjabi: false,
      Sindhi: false,
      Balochi: false,
      Pashto: false,
      Gujarati: false,
      Seraiki: false,
      Balti: false,
      Memoni: false,
      Kashmiri: false,
      Brahui: false,
      Hindko: false,
      Shina: false,
      other: false,
      otherLanguage: '',
    },
    fluentLanguages: {
      Urdu: false,
      English: false,
      Punjabi: false,
      Sindhi: false,
      Balochi: false,
      Pashto: false,
      Gujarati: false,
      Seraiki: false,
      Balti: false,
      Memoni: false,
      Kashmiri: false,
      Brahui: false,
      Hindko: false,
      Shina: false,
      other: false,
      otherLanguage: '',
    },
    readingLanguages: {
      Urdu: false,
      English: false,
      Punjabi: false,
      Sindhi: false,
      Balochi: false,
      Pashto: false,
      Gujarati: false,
      Seraiki: false,
      Balti: false,
      Memoni: false,
      Kashmiri: false,
      Brahui: false,
      Hindko: false,
      Shina: false,
      other: false,
      otherLanguage: '',
    },
    writingLanguages: {
      Urdu: false,
      English: false,
      Punjabi: false,
      Sindhi: false,
      Balochi: false,
      Pashto: false,
      Gujarati: false,
      Seraiki: false,
      Balti: false,
      Memoni: false,
      Kashmiri: false,
      Brahui: false,
      Hindko: false,
      Shina: false,
      other: false,
      otherLanguage: '',
    },
    motherNationality: '',
    fatherNationality: '',
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (category, key, value) => {
    if (category === 'textField') {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [key]: value,
          }));
    } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [category]: {
            ...prevFormData[category],
            [key]: value,
          },
        }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formattedData = {
      student_id: child.id, 
      languages: Object.keys(formData.languages).filter(key => formData.languages[key]),
      school_languages: Object.keys(formData.schoolLanguages).filter(key => formData.schoolLanguages[key]),
      mother_languages: Object.keys(formData.motherLanguages).filter(key => formData.motherLanguages[key]),
      father_languages: Object.keys(formData.fatherLanguages).filter(key => formData.fatherLanguages[key]),
      fluent_languages: Object.keys(formData.fluentLanguages).filter(key => formData.fluentLanguages[key]),
      reading_languages: Object.keys(formData.readingLanguages).filter(key => formData.readingLanguages[key]),
      writing_languages: Object.keys(formData.writingLanguages).filter(key => formData.writingLanguages[key]),
      mother_nationality: formData.motherNationality,
      father_nationality: formData.fatherNationality,
    };

    try {
      await submitLanguageSurveyForm(formattedData);
      notifySuccess('Form submitted successfully');
      setModalVisible(true);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <Container
      sx={{
        p: 4,
        backgroundColor: "white",
        borderRadius: "8px",
        width: "90%",
        maxWidth: "800px",
        margin: "0px auto",
      }}
    >
      <Typography variant="h5" gutterBottom>
        Language Profile Survey Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <LanguageCheckboxGroup
            label="What are the languages spoken at home?"
            category="languages"
            formData={formData}
            handleChange={handleChange}
          />
          <LanguageCheckboxGroup
            label="What languages does the child speak fluently?"
            category="fluentLanguages"
            formData={formData}
            handleChange={handleChange}
          />
          <LanguageCheckboxGroup
            label="What languages does the child comprehend best while reading?"
            category="readingLanguages"
            formData={formData}
            handleChange={handleChange}
          />
          <LanguageCheckboxGroup
            label="What languages is your child most comfortable writing in?"
            category="writingLanguages"
            formData={formData}
            handleChange={handleChange}
          />
          <LanguageCheckboxGroup
            label="Which languages is your child learning at school?"
            category="schoolLanguages"
            formData={formData}
            handleChange={handleChange}
          />

          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              label="What is the nationality of the mother? (write more than one if necessary)"
              name="motherNationality"
              value={formData.motherNationality}
              onChange={(e) => handleChange('textField','motherNationality', e.target.value)}
            />
          </Grid>

          <LanguageCheckboxGroup
            label="What languages does the mother speak fluently?"
            category="motherLanguages"
            formData={formData}
            handleChange={handleChange}
          />
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              label="What is the nationality of the father? (write more than one if necessary)"
              name="fatherNationality"
              value={formData.fatherNationality}
              onChange={(e) => handleChange('textField','fatherNationality', e.target.value)}
            />
          </Grid>

          <LanguageCheckboxGroup
            label="What languages does the father speak fluently?"
            category="fatherLanguages"
            formData={formData}
            handleChange={handleChange}
          />

          <Grid item xs={12}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
      <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
    </Container>
  );
};

export default LanguageSurveyForm;
